import { useEffect } from 'react';

import usePrevious from '~/hooks/usePrevious';

export const useResetPeoplePanelStateOnClipChange = (clipId: string | undefined, onClipChange: () => void) => {
  const previousClipId = usePrevious(clipId);

  useEffect(() => {
    if (previousClipId === undefined || previousClipId === clipId) {
      return;
    }

    onClipChange();
  }, [clipId, onClipChange, previousClipId]);
};
